import React from 'react'
import ContactUs from '../components/contact/contactIs'
import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'


const ContactPage = () => {
    return (
        <>
            <Navbar />
            <ContactUs />
            <Footer />
        </>
    )
}

export default ContactPage